module.exports = __webpack_public_path__ + "img/replay-button.63006fcf.png";